import { SIZE } from "common/sizes";

export const DEFAULT_FONT_FAMILY = "Rubik";

export const KEYS = {
    ENTER: "Enter",
    ARROW_DOWN: "ArrowDown",
    ARROW_UP: "ArrowUp",
    ESCAPE: "Escape",
    TAB: "Tab",
    CLOSE_TAG: ">"
}

export const API_SUFFIX = {
    API_TRIGGER_SUFFIX: "API_REQUEST",
    API_SUCCESS_SUFFIX: "API_SUCCESS",
    API_ERROR_SUFFIX: "API_ERROR"
}

export const BUTTON_ACTION_HEIGHT = `${SIZE.FOUR}px`;